(function () {
  if (window.__gridCarouselInit) return;
  window.__gridCarouselInit = true;

  function setSlide(carousel, index) {
    var total = parseInt(carousel.getAttribute('data-total') || '1', 10);
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    carousel.setAttribute('data-current', index);

    var slides = carousel.querySelectorAll('.grid-product__carousel-slide');
    slides.forEach(function (s) {
      var slideIndex = parseInt(s.getAttribute('data-slide') || '0', 10);
      var active = slideIndex === index;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
      s.setAttribute('tabindex', active ? '0' : '-1');
    });

    var dots = carousel.querySelectorAll('.grid-product__dot');
    dots.forEach(function (d) {
      var dotIndex = parseInt(d.getAttribute('data-dot') || '0', 10);
      d.classList.toggle('is-active', dotIndex === index);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var carousel = btn.closest('[data-grid-carousel]');
    if (!carousel) return;
    e.preventDefault();
    e.stopPropagation();
    var current = parseInt(carousel.getAttribute('data-current') || '0', 10);
    var direction = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    setSlide(carousel, current + direction);
  });

  // Hover-driven swap: enter → slide 1 (second image); leave → slide 0 (primary).
  // Skip on touch / pointer:coarse devices to avoid flicker on tap.
  var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (hoverCapable) {
    function bindHover(carousel) {
      if (carousel.__hoverBound) return;
      carousel.__hoverBound = true;
      carousel.addEventListener('mouseenter', function () {
        var total = parseInt(carousel.getAttribute('data-total') || '1', 10);
        if (total > 1) setSlide(carousel, 1);
      });
      carousel.addEventListener('mouseleave', function () {
        setSlide(carousel, 0);
      });
    }
    function bindAll() {
      document.querySelectorAll('[data-grid-carousel]').forEach(bindHover);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindAll);
    } else {
      bindAll();
    }
    // Re-bind when new product cards are inserted (collection filters, infinite scroll).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-grid-carousel]')) bindHover(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-grid-carousel]').forEach(bindHover);
          }
        }
      }
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();

